<template>
  <CockpitDialog
    title="作业报警列表"
    :top="'200px'"
    :left="'500px'"
    :width="'1000px'"
    :height="'500px'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="flex mb-10px">
        <el-input
          v-model="searchText"
          placeholder="请输入关键词"
          size="small"
          clearable
          class="w-200px mr-10px"
        ></el-input>
        <el-select clearable v-model="alarmType" placeholder="报警类型" class="mr-10px w-200px" popper-class="visualization-select-popper">
          <el-option
            v-for="item in alarmTypeList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-select clearable v-model="handleState" placeholder="处理状态" class="mr-10px w-200px" popper-class="visualization-select-popper">
          <el-option
            v-for="item in handleStateList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px w-220px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchTime"
          popper-class="visualization-picker-popper"
          clearable
        ></el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
        <el-button size="small" type="primary" @click="reset">重置</el-button>
      </div>
      <el-table
        ref="tableRef"
        height="calc(100% - 80px)"
        class="mt-10px"
        :data="detailList"
        highlight-current-row
        v-loading="warningLoading"
      >
        <el-table-column label="序号" type="index" width="50px" show-overflow-tooltip></el-table-column>
        <el-table-column label="报警名称" prop="name" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="关联作业类型" prop="ticketTypeName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="报警位置" prop="fenceName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="报警类型" prop="alarmTypeName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="报警对象" prop="personNames" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="报警状态" prop="alarmRemoveTypeStr" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="开始时间" prop="eventStartTime" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="结束时间" prop="handleTime" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="处理状态" prop="handleStateStr" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="处理意见" prop="handleAdvice" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="{ row }">
            <span class="cursor-pointer" @click="openAlarmHandleDialog(row)" v-if="row.handleState === 0"
              >处理</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="getWarningList"
        :current-page.sync="pageInfo.pageNo"
        :page-size.sync="pageInfo.pageSize"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        class="text-center"
      ></el-pagination>
    </div>
    <CockpitDialog
      v-if="handleDialogVisible"
      title="处理意见"
      :top="'300px'"
      :left="'700px'"
      :width="'500px'"
      :height="'250px'"
      @close="handleDialogVisible = false"
    >
      <el-form ref="form" label-width="80px" :model="formData">
        <el-form-item
          label="处理意见"
          prop="advice"
          :rules="[{ required: true, message: '请填写处理意见', trigger: ['change', 'blur'] }]"
        >
          <el-input
            placeholder="请输入处理意见"
            maxlength="50"
            type="textarea"
            rows="3"
            v-model="formData.advice"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="flex justify-center items-center">
        <el-button
          :loading="handleLoading"
          size="small"
          type="primary"
          class="iconfont icon-save"
          @click="saveAdvice"
          >处理</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="handlingDialogclose">取消</el-button>
      </div>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import { isEmpty, map, omit, omitBy, isNil, eq, get, uniqBy, find, compact } from 'lodash'
import {
  StandardAlarmSettingApi,
  StandardAlarmRecordApi,
} from '@wiz-api/personnel-position'
import { WorkTicketsApi } from '@wiz-api/huizhou2-business'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

const alarmRecordApi = new StandardAlarmRecordApi()
const alarmSettingApi = new StandardAlarmSettingApi()
const workTicketsApi = new WorkTicketsApi()

export default {
  name: 'WorkAlarmList',
  components: {
    CockpitDialog
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      handleDialogVisible: false,
      warningLoading: false,
      handleLoading: false,
      alarmTypeList: [],
      handleStateList: [
        {
          value: 0,
          label: '待处理'
        },
        {
          value: 1,
          label: '已处理'
        }
      ],
      detailList: [],
      searchText: '',
      alarmType: '',
      handleState: '',
      searchTime: [],
      relevanceList: [],
      standardFenceIds: [],
      standardFenceIdsStr: '',
      pageInfo: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      currentId: '',
      formData: {
        advice: ''
      },
    }
  },
  created() {
    this.getAlarmTypeList()
    this.getWarningList()
  },
  methods: {
    // 获取报警类型
    async getAlarmTypeList() {
      const [err, res] = await alarmSettingApi.getAlarmTypesFromSetting({ type: 0 })
      if (!err && res) {
        Object.keys(res).forEach((key) => {
          this.alarmTypeList.push({
            label: res[key],
            value: key,
          })
        })
      }
    },
    // 获取关联列表
    async getRelevanceList() {
      const [err, res] = await workTicketsApi.getWorkTicketStandardFenceRelevanceByList({
        body: {
          workTicketIds: [],
          standardFenceIds: [],
        }
      })
      if (!err && res) {
        this.relevanceList = res.items
        // 关联作业类型下拉数据源
        this.standardFenceIds = compact(map(this.relevanceList, 'standardFenceId'))
        this.standardFenceIdsStr = this.standardFenceIds.join(',')
      }
    },
    // 获取全部报警数据
    async getWarningList() {
      this.warningLoading = true
      await this.getRelevanceList()
      if (!this.standardFenceIdsStr) {
        this.warningLoading = false
        return
      }
      const [err, res] = await alarmRecordApi.getList({
        name: this.searchText,
        alarmType: this.alarmType,
        handleState: this.handleState,
        standardFenceIdsStr: this.standardFenceIdsStr,
        startTime: isEmpty(this.searchTime) ? '' : this.searchTime[0],
        endTime: isEmpty(this.searchTime) ? '' : this.searchTime[1],
        maxResultCount: this.pageInfo.pageSize,
        skipCount: (this.pageInfo.pageNo - 1) * this.pageInfo.pageSize,
      })
      if (!err && res) {
        this.detailList = map(res.items, item => {
          const obj = find(this.relevanceList, {standardFenceId: item.standardFenceId})
          if (obj) {
            item.ticketTypeName = obj.ticketTypeName
          }
          return {
            ...item,
            eventStartTime: moment(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss'),
            eventEndTime: item.eventEndTime ? moment(item.eventEndTime).format('YYYY-MM-DD HH:mm:ss') : '',
            handleTime: item.handleTime ? moment(item.handleTime).format('YYYY-MM-DD HH:mm:ss') : item.handleTime,
            name: item.personNames + item.alarmTypeName + item.fenceName
          }
        })
        this.pageInfo.total = res.totalCount
      }
      this.warningLoading = false
    },
    handleSizeChange(val) {
      this.removeAlarmPage.pageNo = 1
      this.getWarningList()
    },
    reset() {
      this.searchText = ''
      this.alarmType = ''
      this.handleState = ''
      this.searchTime = []
      this.getWarningList()
    },
    // 搜索
    handleSearch() {
      this.pageInfo.pageNo = 1
      this.getWarningList()
    },
    openAlarmHandleDialog(row) {
      this.currentId = row.id
      this.handleDialogVisible = true
      this.advice = row.handleAdvice
    },
    close() {
      this.$emit('update:isShowDialog', false)
    },
    handlingDialogclose() {
      this.handleDialogVisible = false
    },
    // 处理报警
    async saveAdvice() {
      this.handleLoading = true
      const [err, res] = await alarmRecordApi.confirmAlarm(this.currentId, {
        advice: this.formData.advice,
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '处理成功',
          type: 'success',
        })
      }
      this.handleLoading = false
      this.getWarningList()
      this.handlingDialogclose()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>